import React from 'react';
export function Footer() {
  return <footer className="bg-cream py-12 border-t border-sand/30" data-id="element-45">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-46">
        <div className="flex flex-col leading-tight text-center md:text-left" data-id="element-47">
          <span className="font-serif text-2xl font-semibold tracking-wide text-stone-deep" data-id="element-48">
            Labenske + Patton
          </span>
          <span className="font-sans text-[10px] uppercase tracking-[0.25em] text-sand mt-0.5" data-id="element-49">
            HomeSmart NEXT
          </span>
        </div>

        <nav className="flex items-center space-x-6" data-id="element-50">
          <a href="#about" className="text-sm uppercase tracking-widest text-stone-deep/60 hover:text-brown transition-colors" data-id="element-51">
            About
          </a>
          <a href="#why-carefree" className="text-sm uppercase tracking-widest text-stone-deep/60 hover:text-brown transition-colors" data-id="element-52">
            Location
          </a>
          <a href="#schedule" className="text-sm uppercase tracking-widest text-stone-deep/60 hover:text-brown transition-colors" data-id="element-53">
            Contact
          </a>
        </nav>

        <div className="text-sm text-stone-deep/50 text-center md:text-right" data-id="element-54">
          &copy; {new Date().getFullYear()} Labenske + Patton · HomeSmart NEXT.{' '}
          <br className="md:hidden" data-id="element-55" /> All rights reserved.
        </div>
      </div>
    </footer>;
}